import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=4ef40e02&scoped=true&"
import script from "./brandList.vue?vue&type=script&lang=js&"
export * from "./brandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef40e02",
  null
  
)

export default component.exports